<template>
  <div class='service-provider-freelancer-profile'>
    <avatar-upload  class="avatar" :file-url="fileUrl"  @changed='updateAvatarUrl'/>
    <div class='form' v-if='showForm'>
      <edit-service-provider-freelancer-profile-form @formChanged='formChanged' class='profile-form'/>
      <div class="actions d-flex">
        <v-btn color="primary" class='submit-form' @click="submit" :disabled='!saveEnabled'>
          {{ $t('save') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AvatarUpload from '@/components/common/AvatarUpload.vue';
import EditServiceProviderFreelancerProfileForm from '@/components/forms/EditServiceProviderFreelancerProfileForm.vue';
import {
  UPDATE_SERVICE_PROVIDER_FREELANCER_PROFILE,
} from '@/store/user/actionTypes';

export default {
  name: 'ServiceProviderFreelancerProfile',
  components: {
    AvatarUpload,
    EditServiceProviderFreelancerProfileForm,
  },
  data() {
    return {
      saveEnabled: true,
    };
  },
  computed: {
    ...mapGetters([
      'serviceProviderFreelancerProfileDetails',
    ]),
    showForm() {
      return this.serviceProviderFreelancerProfileDetails?.user && this.serviceProviderFreelancerProfileDetails?.workerProfile;
    },
    fileUrl() {
      if (!this.serviceProviderFreelancerProfileDetails?.user?.avatarURL || this.serviceProviderFreelancerProfileDetails?.user?.avatarURL?.startsWith('data')) {
        return this.serviceProviderFreelancerProfileDetails?.user?.avatarURL;
      }
      return `${this.serviceProviderFreelancerProfileDetails?.user?.avatarURL}?${Date.now().toString()}` || null;
    },
  },
  methods: {
    updateAvatarUrl(file) {
      this.serviceProviderFreelancerProfileDetails.user.avatarURL = file;
    },
    formChanged(valid) {
      if (valid) {
        this.saveEnabled = true;
      } else {
        this.saveEnabled = false;
      }
    },
    async submit() {
      if (this.saveEnabled) {
        await this.$store.dispatch(UPDATE_SERVICE_PROVIDER_FREELANCER_PROFILE, this.serviceProviderFreelancerProfileDetails);
      }
    },
  },
};
</script>

<style lang='scss'>
@import '../../assets/styles/variables';
.service-provider-freelancer-profile {
  display: flex;
  flex: 1;

  padding-top: 40px;
  padding-bottom: 40px;
  margin-left: 10%;

  padding-right: 152px;

  border-radius: 4px;
  background-color: $default-background-color;
}

.form {
  flex: 1;
  display: flex;
  flex-direction: column;
  .profile-form {
    flex: 1;
    max-width: 90%;
  }
}

.avatar {
  flex: 0.35;
  margin-right: 7%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.submit-form {
  margin-top: 20px;
}
</style>
